import { Grid, Tooltip, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { IVesselKPIColumn } from '../../models/vessel-kpi'
import { TableCentralizedCell } from '../atoms/TableCentralizedCell'
import { VesselKpiTableCell } from '../atoms/VesselKpiTableCell'

interface Props {
  column: IVesselKPIColumn
  skipTotal?: boolean
}
export const VesselTableHeader = observer(({ column, skipTotal = false }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Grid container width={'100%'} rowSpacing={theme.customSpacing.m}>
      <Grid size={12}>
        <TableCentralizedCell>
          {column.craneId ? column.label : t(column.label, column.label)}
        </TableCentralizedCell>
      </Grid>

      {column.hasInbound && (
        <VesselKpiTableCell column={column} skipTotal={skipTotal}>
          <Tooltip title={t('discharge', 'Discharge')}>
            <Typography textAlign={'center'} variant='subtitle1'>
              {t('dc', 'DC')}
            </Typography>
          </Tooltip>
        </VesselKpiTableCell>
      )}

      {column.hasOutbound && (
        <VesselKpiTableCell column={column} skipTotal={skipTotal}>
          <Tooltip title={t('load', 'Load')}>
            <Typography textAlign={'center'} variant='subtitle1'>
              {t('ld', 'LD')}
            </Typography>
          </Tooltip>
        </VesselKpiTableCell>
      )}

      {column.hasRestow && (
        <VesselKpiTableCell column={column} skipTotal={skipTotal}>
          <Tooltip title={t('restow', 'Restow')}>
            <Typography textAlign={'center'} variant='subtitle1'>
              {t('r', 'R')}
            </Typography>
          </Tooltip>
        </VesselKpiTableCell>
      )}

      {!skipTotal && (
        <VesselKpiTableCell column={column} skipTotal={skipTotal} value={t('total', 'Total')} />
      )}
    </Grid>
  )
})
